<mat-form-field
  *ngIf="control"
  appearance="outline"
  ngClass="ks-input-{{ size }} ks-input-{{ color }}"
  [class.ks-input-no-space]="!errors.length"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <textarea
    #input
    *ngIf="isTextarea"
    matInput
    [id]="id"
    [rows]="rows"
    [maxlength]="maxlength"
    [placeholder]="placeholder"
    [formControl]="control"
    [required]="required"
    [readonly]="readonly"
    (focus)="focused.emit()"
    (blur)="blurred.emit()"
  ></textarea>
  <input
    #input
    *ngIf="!isTextarea"
    matInput
    [id]="id"
    [type]="type"
    [mask]="mask"
    [min]="min"
    [max]="max"
    [maxlength]="maxlength"
    [placeholder]="placeholder"
    [formControl]="control"
    [required]="required"
    [readonly]="readonly"
    (focus)="focused.emit()"
    (blur)="blurred.emit()"
  />
  <mat-error *ngIf="errors.length" class="ks-input-error">
    <ng-container *ngFor="let error of errors">
      <span
        *ngIf="control.hasError(error.validation) && (control.dirty || control.touched)"
        class="ks-text-1lns"
      >
        <span inlineSVG="assets/icons/Error.svg" class="ks-input-error__icon"></span
        >{{ error.message }}
      </span>
    </ng-container>
  </mat-error>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>
